// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"403":"a41887fa","500":"5c655e1b","688":"559ebdee"}[chunkId] + ".chunk.css";
};